import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { GcssLayout } from '@/components/layout/GcssLayout';
import { ResultContent } from '@/sections/gcss/ResultContent';
import { FIELD_FULLTEXT, useGcssValuesToSearch } from '@/sections/gcss/hooks/useGcssSearch';
import { getNoResultsData, type NoResults } from '@/sections/gcss/functions/getNoResultsData';
import { getHeaderSections } from '@/sections/gcss/functions/getHeaderSections';
import { Section } from '@/sections/layout/Header/useGcssSections';
import { isAllowedRoute } from '@/lang/pagesConfig';
interface Props extends IntlProps {
  noResultsData: NoResults;
  headerSections: Section[];
}
export default function Page(props) {
  const $ = _c(14);
  usePageView("gcss-homepage-search");
  const {
    noResultsData,
    headerSections
  } = props;
  const {
    formValues,
    sync,
    searchForm
  } = useGcssValuesToSearch();
  let t0;
  if ($[0] !== formValues || $[1] !== sync) {
    t0 = () => sync({
      [FIELD_FULLTEXT]: formValues[FIELD_FULLTEXT]
    });
    $[0] = formValues;
    $[1] = sync;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== formValues || $[4] !== noResultsData || $[5] !== searchForm || $[6] !== sync) {
    t1 = <ResultContent noResultsData={noResultsData} searchForm={searchForm} formValues={formValues} sync={sync} />;
    $[3] = formValues;
    $[4] = noResultsData;
    $[5] = searchForm;
    $[6] = sync;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== formValues || $[9] !== headerSections || $[10] !== searchForm || $[11] !== t0 || $[12] !== t1) {
    t2 = <GcssLayout handleResetFilter={t0} headerSections={headerSections} searchForm={searchForm} formValues={formValues}>{t1}</GcssLayout>;
    $[8] = formValues;
    $[9] = headerSections;
    $[10] = searchForm;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('srovnavac-produktu/vyhledavani');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      noResultsData: await getNoResultsData(),
      headerSections: await getHeaderSections(),
      ...(await getIntlProps(ctx, ['core', 'gcss']))
    }
  };
}) satisfies GetStaticProps<Props>;